module.exports = __webpack_public_path__ + "assets/26cd5798fb3911b98763666a08d468e3.png";